function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 21.3c-2.9 0-5.7-1.4-7.5-3.8v2.1c0 .4-.3.7-.7.7h-.4c-.4 0-.7-.4-.7-.8V14h5.2c.4 0 .7.3.7.7v.4c0 .4-.3.7-.7.7H5.6c1.4 2.3 3.8 3.6 6.4 3.6 4 0 7.2-3.1 7.4-7 0-.3.3-.7.7-.7h.4c.5 0 .8.3.8.8-.3 4.9-4.4 8.8-9.3 8.8zm-8.5-9c-.5 0-.8-.3-.8-.8C3 6.6 7.1 2.7 12 2.7c2.9 0 5.7 1.4 7.5 3.8V4.4c0-.4.3-.7.7-.7h.4c.4 0 .7.3.7.7v5.5h-5.2c-.4 0-.7-.3-.7-.7v-.4c0-.4.3-.7.7-.7h2.3C17 5.8 14.6 4.5 12 4.5c-4 0-7.2 3.1-7.4 7.1 0 .3-.3.7-.7.7h-.4z"
}));